import { render } from "./DistributionMap.vue?vue&type=template&id=1978b576&scoped=true"
import script from "./DistributionMap.vue?vue&type=script&lang=js"
export * from "./DistributionMap.vue?vue&type=script&lang=js"

import "./DistributionMap.vue?vue&type=style&index=0&id=1978b576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1978b576"]])

export default __exports__